module.exports = __webpack_public_path__ + "img/task_detail_setting_2.845fd69.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/setting-wizard/task_detail_setting_2.svg
// module id = 06Yn
// module chunks = 1